module.exports = __webpack_public_path__ + "static/looping-black-100958204539abb4efe822b562437acc.mp4";